import Resources from '../../helpers/resources';

export const GET_DUCS_CONFIG_REQUESTED = 'GET_DUCS_CONFIG_REQUESTED';
export const GET_DUCS_CONFIG_SUCCESS = 'GET_DUCS_CONFIG_SUCCESS';
export const GET_DUCS_CONFIG_ERROR = 'GET_DUCS_CONFIG_ERROR';

export const SET_DUCS_INSTANCE_ID = 'SET_DUCS_INSTANCE_ID';

export const getDucsConfigRequested = () => ({
  type: GET_DUCS_CONFIG_REQUESTED
});
export const getDucsConfigSuccess = payload => ({
  type: GET_DUCS_CONFIG_SUCCESS,
  ...payload
});
export const getDucsConfigError = () => ({
  type: GET_DUCS_CONFIG_ERROR
});
export const getDucsConfig = () => async (dispatch) => {
  dispatch(getDucsConfigRequested());
  try {
    const [url, config] = await Promise.all([
      Resources.env.substituteConfigurationItems('@DUCSLibraryUrl'),
      Resources.env.substituteConfigurationItems('@DUCSConfiguration')
    ]);
    dispatch(getDucsConfigSuccess({ url, config: JSON.parse(config) }));
  } catch (error) {
    dispatch(getDucsConfigError());
  }
};



// WEBPACK FOOTER //
// ./containers/ducs/actions.js